import React, { useEffect, useState } from "react";
import axios from "axios";
import path from "../../path";

const DoctorSuggestion = () => {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${path}/v1/lead/doctor-list`);

        setDoctors(response.data.data);
        setLoading(false);
      } catch (error) {
        console.log("error", error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <h1>hello...</h1>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          {doctors.map((doctor) => (
            <div key={doctor.id}>
              <h3>{doctor.firstName}</h3>
              <img src={`${path}/${doctor.icon}`} alt="icon" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DoctorSuggestion;

// import {
//   setAnswerValue,
//   getAnswerValue,
//   clearAnswerValue,
//   getSemanticAnswerValue,
//   getAllAnswerValues,
//   getResponderUuid,
//   setDisableBackNavigation,
// } from "@formsort/custom-question-api";
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import path from "../../path";
// // import "./newForm.css";
// import "./form.css";
// import SignUp from "../../pages/SignUp";

// const NewForm = () => {
//   const [doctors, setDoctors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [answers, setAnswers] = useState({
//     name: "",
//     age: null,
//   });

//   useEffect(() => {
//     const setAnswerValues = async () => {
//       const answerValue = await getAnswerValue();
//       setAnswers({
//         ...answers,
//         name: answerValue?.name || "",
//         age: answerValue?.age || null,
//       });
//     };
//     setAnswerValues();
//   }, []);

//   const setName = (event) => {
//     const newData = { ...answers, name: event.target.value };
//     setAnswers(newData);
//     setAnswerValue(newData);
//   };
//   const setAge = (event) => {
//     const newData = { ...answers, age: event.target.value };
//     setAnswers(newData);
//     setAnswerValue(newData);
//   };

//   // useEffect(() => {
//   //   const fetchData = async () => {
//   //     try {
//   //       const response = await axios.get(`${path}/v1/lead/doctor-list`);

//   //       setDoctors(response.data.data);
//   //       console.log(response.data.data, "----------");
//   //       setLoading(false);
//   //     } catch (error) {
//   //       console.log("error", error);
//   //       setLoading(false);
//   //     }
//   //   };
//   //   fetchData();
//   // }, []);

//   return (
//     <div id="main-flow">
//       <div id="custom-flow">
//         <h1>hello..</h1>
//         <div>
//           What is your name?
//           <br />
//           <input
//             type="text"
//             value={answers.name}
//             onChange={(event) => setName(event)}
//           />
//         </div>
//         <br />
//         <div>
//           What is your age?
//           <br />
//           <input
//             type="number"
//             value={Number(answers.age)}
//             onChange={(event) => setAge(event)}
//           />
//         </div>
//         {loading ? (
//           <p>Loading...</p>
//         ) : (
//           <div>
//             {doctors.map((doctor) => (
//               <div key={doctor.id}>
//                 <h3>{doctor.firstName}</h3>
//                 <img
//                   id="user-icon"
//                   src={doctor.icon ? `${path}/${doctor.icon}` : "user.svg"}
//                   alt="icon"
//                 />
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default NewForm;

// // import React from "react";

// // const NewForm = () => {
// //   return (
// //     <div>
// //       <h1>hello</h1>
// //     </div>
// //   );
// // };

// // export default NewForm;
